import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Card } from "@/components/ui/card";
import { Navigation } from "@/components/Navigation";
import { Session } from "@supabase/supabase-js";

interface StatusProps {
  session: Session;
}

const Status = ({ session }: StatusProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        navigate("/");
      }
    };
    checkAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-skuhub-navy">
      <Navigation session={session} />
      <div className="container mx-auto px-4 py-24">
        <Card className="p-6 bg-white/5 backdrop-blur-sm border-white/10">
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <span className="text-gray-300">Status Dashboard</span>
              <span className="text-yellow-500">Coming Soon</span>
            </div>
            <div className="text-gray-400 text-sm">
              Health check functionality will be implemented soon.
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Status;